// ASPAB Site Constants & Image URLs
// Design: Clean white/light theme with blue accents
// All heavy images optimized to WebP (16.5 MB total savings)

export const IMAGES = {
  // Logos - Blue/red/gray laser symbol + ASPAB text (small, no optimization needed)
  logo: "/images/FeuWpbtjAwIHFvNz.png",
  logoIcon: "/images/omQmPdMPfyxGwwhW.png",
  logo32: "/images/HBgZeLdTttybasBj.png",
  logoLarge: "/images/cWsSnlZCUCwhcveY.webp",
  favicon: "/images/HBgZeLdTttybasBj.png",

  // Hero / Laser cutting (optimized WebP)
  heroLaser: "/images/HPZdCipNfTEtikkn.webp",
  laserCutting: "/images/AgWXQDMIhJEkeGFb.webp",

  // Workshop photos (optimized WebP)
  workshop1: "/images/dyBqOFGMUSuXYMOg.webp",
  workshop2: "/images/yVDmkjIQxzVluDuG.webp",
  workshop3: "/images/wuIKCXMAXtvTyTNG.webp",
  workshop4: "/images/NOozwVPnovdsNAAH.webp",
  workshopOverview: "/images/ngIoJsenIheoQtWQ.webp",

  // Closeup / detail photos (optimized WebP)
  closeup1: "/images/BdHfLWPfZtxZHJGr.webp",
  closeup2: "/images/QEjFZAqrmxoyDazi.webp",
  detail: "/images/FYYGsjjFmDWGxOMd.webp",
  screenshot: "/images/xoonWhJjXhvqMWKe.webp",

  // Team photos (optimized WebP)
  team1: "/images/aQgpLpEAMNYHyBco.webp",
  team2: "/images/rQXKTBTcdDdYjMFG.webp",

  // Reference / Client photos (optimized WebP)
  caroliner1: "/images/mijzWihviASvJvxW.webp",
  caroliner2: "/images/rxfBeeKrbsDOJXvj.webp",

  // Media from old aspab.com (already optimized or special format)
  laserVideo: "/images/hero_video_compressed_0e106bda.mp4",
  kreditvardighet: "/images/iWnXHMmkyANPTvgE.svg",
  branschvinnare2026: "/brand-assets/branschvinnare-2026-aspab",
  branschvinnare2026Light: "/brand-assets/branschvinnare-2026-aspab-ljus",
  robinFischer: "/images/TJEyEIOIbCmjqaHh.webp",
  snabbLeverans: "/images/pCSXdoSRrJKhEiAe.webp",
  laserOldSite: "/images/uxCdqpOrVyXhUlOp.webp",
  svetsningOldSite: "/images/RfrIzZoSDoFBIkRy.webp",
  referensCaroliner: "/images/kuwIZshkNQhrqOUc.webp",
  referensVolvo: "/images/sPWFBZtSLVyhoxqN.webp",
  teamOldSite: "/images/XgHpKNXxlUsYnvcc.webp",

  // Blog images
  lissmacMaskin: "/images/lissmac-gradningsmaskin_fd81ff2b.webp",

  // OG images (1200x630, per page)
  ogHem: "/images/hem_aca29488.png",
  ogTjanster: "/images/tjanster_9614a8e1.png",
  ogLaserskarning: "/images/tjanster-laserskarning_eae87404.png",
  ogKantpressning: "/images/tjanster-kantpressning_a8084f9b.png",
  ogSvetsning: "/images/tjanster-svetsning_523882f1.png",
  ogMaskinpark: "/images/maskinpark_69ed1a67.png",
  ogOmOss: "/images/om-oss_ce18d842.png",
  ogReferenser: "/images/referenser_3e76b82b.png",
  ogKontakt: "/images/kontakt_5773cba8.png",
  ogNyheter: "/images/nyheter_4d0c26bc.png",
  ogLissmac: "/images/nyheter-lissmac-gradningsmaskin_a4e60f0e.png",
  ogStockholm: "/images/laserskarning-stockholm_3b0f0114.png",
  ogVasteras: "/images/laserskarning-vasteras_dbebb986.png",
  ogOrebro: "/images/laserskarning-orebro_581d80d8.png",
  ogNorrkoping: "/images/laserskarning-norrkoping_4368baa7.png",
  ogLinkoping: "/images/laserskarning-linkoping_ae811ea6.png",
  // Pillar page OG images
  ogPillarLaser: "/images/og-kunskapsbank-laserskarning_28b02653.png",
  ogPillarKantpress: "/images/og-kunskapsbank-kantpressning_8b143747.png",
  ogPillarSvets: "/images/og-kunskapsbank-svetsning_4741b6be.png",
  ogPillarMaterial: "/images/og-kunskapsbank-material_a9ddfa8e.png",
  ogPillarBransch: "/images/og-kunskapsbank-bransch_09595752.png",
  ogPillarGuider: "/images/og-kunskapsbank-guider_081b8126.png",
  ogPillarFramtid: "/images/og-kunskapsbank-framtid_30c37c75.png",
  // Author OG images
  ogForfattare: "/images/og-forfattare_5a7c357c.png",
  ogForfattareRobinFischer: "/images/og-forfattare-robin-fischer_8873f6a7.png",
} as const;

export const CONTACT = {
  phone: "016-13 26 00",
  email: "order@aspab.com",
  address: "Abramsons väg 2",
  city: "632 39 Eskilstuna",
  orgNr: "556474-5056",
} as const;

export const NAV_ITEMS = [
  { label: "Tjänster", href: "/tjanster", children: [
    { label: "Laserskärning", href: "/tjanster/laserskarning" },
    { label: "Kantpressning", href: "/tjanster/kantpressning" },
    { label: "Svetsning", href: "/tjanster/svetsning" },
  ]},
  { label: "Maskinpark", href: "/maskinpark" },
  { label: "Om oss", href: "/om-oss" },
  { label: "Referenser", href: "/referenser", children: [
    { label: "Volvo", href: "/referenser/volvo" },
    { label: "Försvarsindustrin", href: "/referenser/forsvarsindustrin" },
  ]},
  { label: "Nyheter", href: "/nyheter" },
  { label: "Kontakt", href: "/kontakt" },
] as const;
